import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';

const LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/products', label: 'Products' },
  { to: '/governance', label: 'REGULATION', gold: true },
  { to: '/qa', label: 'Q&A' },
  { to: '/about', label: 'About' },
  { to: '/origin', label: 'Origin' },
  { to: '/team', label: 'Meet Us' },
  { to: '/careers', label: 'Careers' },
  { to: '/contact', label: 'Contact' },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav className={`nn-navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nn-nav-inner">
        <img
          src="/assets/nexus_neuro_logo.webp"
          alt="NeXus NeuroInformatics, Inc."
          className="nn-nav-wordmark"
        />
        <span className="nn-nav-parent">A Nexus Concordat Company</span>

        <button
          type="button"
          className={`nn-nav-toggle ${mobileOpen ? 'open' : ''}`}
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span className="nn-nav-toggle-line" />
          <span className="nn-nav-toggle-line" />
          <span className="nn-nav-toggle-line" />
        </button>

        <div className={`nn-nav-links ${mobileOpen ? 'open' : ''}`}>
          {LINKS.map(({ to, label, end, gold, external }) => (
            external ? (
              <a
                key={to}
                href={to}
                target="_blank"
                rel="noopener noreferrer"
                className={`nn-nav-link${gold ? ' nn-nav-link-gold' : ''}`}
              >
                {label}
              </a>
            ) : (
              <NavLink
                key={to}
                to={to}
                end={end || false}
                className={({ isActive }) => `nn-nav-link${isActive ? ' active' : ''}${gold ? ' nn-nav-link-gold' : ''}`}
              >
                {label}
              </NavLink>
            )
          ))}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
